module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-afterword element-without-heading full-character-formatting",
    attrs: {
      "id": "afterword"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "afterword-text"
    }
  }, [_c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-large inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall inline-image-without-caption inline-image-begins-section inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "https://www.aileenerin.com/subscribe",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Subscribe to Aileen’s newsletter!",
      "src": "images/backmatter---newsletter-1.jpg"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.aileenerin.com/subscribe",
      "target": "_blank"
    }
  }, [_vm._v("Click here to subscribe!")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-569739a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/want-updates-from-aileen.vue
// module id = 69
// module chunks = 0